import { Skeleton } from "@/components/ui/skeleton";
import { memo } from "react";

function DetailRowSkeleton() {
  return (
    <div className="mb-5 flex gap-3">
      <Skeleton variant="shimmer" className="size-6 shrink-0 rounded-full" />
      <div className="min-w-0 flex-1 space-y-2">
        <Skeleton variant="shimmer" className="h-2.5 w-24 rounded-full" />
        <Skeleton variant="shimmer" className="h-4 w-3/4 rounded-full" />
      </div>
    </div>
  );
}

function QuickInfoCardSkeleton() {
  return (
    <div className="flex items-center gap-2.5 rounded-3xl border border-[#c3c6d7] bg-[#fcfcfc] p-4">
      <Skeleton variant="shimmer" className="size-6 shrink-0 rounded-full" />
      <Skeleton variant="shimmer" className="h-3.5 w-28 rounded-full" />
    </div>
  );
}

/** Placeholder shimmer que espelha o layout de `InscricaoConfirmacaoEmailView`. */
export const InscricaoConcluidaSkeleton = memo(function InscricaoConcluidaSkeleton() {
  return (
    <div className="space-y-6 pb-4" aria-hidden>
      {/* Card de detalhes do evento (capa + título + linhas) */}
      <div className="overflow-hidden rounded-3xl border border-[#c3c6d7] bg-[#fcfcfc]">
        <Skeleton variant="shimmer" className="h-48 w-full rounded-none" />
        <div className="p-6">
          <Skeleton variant="shimmer" className="mb-6 h-5 w-2/3 rounded-full" />
          <DetailRowSkeleton />
          <DetailRowSkeleton />
          <DetailRowSkeleton />
        </div>
      </div>

      {/* Card do portal */}
      <div className="rounded-3xl border border-[#c3c6d7] bg-[#fcfcfc] px-6 py-8 text-center">
        <Skeleton variant="shimmer" className="mx-auto mb-3 h-5 w-40 rounded-full" />
        <Skeleton variant="shimmer" className="mx-auto mb-1.5 h-3 w-64 max-w-full rounded-full" />
        <Skeleton variant="shimmer" className="mx-auto mb-6 h-3 w-48 max-w-full rounded-full" />
        <Skeleton variant="shimmer" className="mx-auto h-10 w-40 rounded-full" />
      </div>

      {/* Cards de informações rápidas */}
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <QuickInfoCardSkeleton />
          <QuickInfoCardSkeleton />
        </div>
        <QuickInfoCardSkeleton />
      </div>
    </div>
  );
});
